import Vue from "vue";

export const RollbarNotify = new (class RollbarNotify {
  critical(message: string) {
    Vue.rollbar.critical(message);
  }
  error(message: string) {
    Vue.rollbar.error(message);
  }
  warning(message: string) {
    Vue.rollbar.warning(message);
  }
  info(message: string) {
    Vue.rollbar.info(message);
  }
  debug(message: string) {
    Vue.rollbar.debug(message);
  }
})();
